export const roleDashboard = {
  SUPER_ADMIN: '/admin/dashboard',
  SALON_MANAGER: '/salon/dashboard',
  SALON_STAFF: '/staff/dashboard',
  CLIENT: '/client/dashboard',
};

export const getDashboardPath = (role, user) => {
  if (role === 'SALON_STAFF' && user?.staffRegistrationRejected) {
    return '/staff/registration-rejected';
  }
  if (role === 'SALON_STAFF' && user?.staffPendingApproval) {
    return '/staff/pending-approval';
  }
  return roleDashboard[role] || '/login';
};
